import React from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/auth";
import { fmtDate } from "@/lib/datetime";
import { Switch } from "@/components/ui/switch";

export function BalanceRemindersCard({ order, onReload }) {
  const hasBalance = (order.payment_plan?.steps || []).some((s) => s.key === "balance");
  if (!hasBalance) return null;
  const toggle = async (enabled) => {
    try {
      await api.patch(`/admin/orders/${order.id}/balance-reminders`, { enabled });
      toast.success(enabled ? "Rappels de solde activés" : "Rappels de solde désactivés");
      onReload();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const sent = order.balance_reminders || [];
  return (
    <div className="cs-card p-6" data-testid="balance-reminders-card">
      <div className="flex items-center justify-between gap-3">
        <div className="cs-eyebrow text-[#0E7C90]">Rappels de solde</div>
        <Switch checked={order.balance_reminders_enabled} onCheckedChange={toggle} data-testid="balance-reminders-toggle" />
      </div>
      <p className="mt-2 text-[13px] text-neutral-600">
        Rappel automatique 7, 14 puis 21 jours après la livraison tant que le solde n'est pas réglé
        {order.payer === "end_client" ? " — envoyé au studio, pour relancer le client final." : " — envoyé au client."}
      </p>
      {sent.length > 0 && (
        <ul className="mt-3 text-[12px] font-mono text-neutral-500 space-y-1" data-testid="balance-reminders-list">
          {sent.map((r) => <li key={r.n}>Rappel n°{r.n} · {fmtDate(r.at)} · {r.to === "admin" ? "studio" : "client"}</li>)}
        </ul>
      )}
    </div>
  );
}
